import { SET_PAGINATION, USER_LOGIN, USER_LOGOUT } from './constants';
import { LoginLight, loginUser } from '../api/auth';

export const signInUser = (values, type = 'main') => {
    return async (dispatch) => {
        try {
            let userData;
            if (type == 'light') {
                userData = await LoginLight(values);
            } else {
                userData = await loginUser(values);
            }
            if (userData?.token) {
                localStorage.setItem('ccms-user', JSON.stringify(userData));
                await dispatch({
                    type: USER_LOGIN,
                    payload: userData,
                });

                return Promise.resolve(userData);
            } else {
                return Promise.reject({ message: userData?.message || 'No token recieved' });
            }
        } catch (error) {
            return Promise.reject(error);
        }
    };
};

export const signOutUser = () => {
    return async (dispatch) => {
        try {
            localStorage.removeItem('ccms-user');
            window.location.reload();
            await dispatch({
                type: USER_LOGOUT,
            });
            return Promise.resolve(true);
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        }
    };
};

export const updatePageSize = (size = 50) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_PAGINATION,
            payload: size,
        });
        return Promise.resolve(true);
    };
};
